import { DependencyInjectId } from "@@/package/const/DependencyInjectId";
import HttpClient from "@@/package/network/HttpClient";
import { type ApplicationContextInterface } from "@@/package/application/applicationContext";
import { Axios, type AxiosResponse } from "axios";
import {
  OrganizationProSkillManagerInfoModel
} from "~~/package/mapper/organization/model/OrganizationProSkillManagerInfoModel";
import type CustomResponse from "~~/package/types/ResponseType";
import { OrganizationSettingsInfoModel } from "~~/package/mapper/organization/model/OrganizationSettingsInfoModel";
import type {PageModel} from '~~/package/mapper/common/model/PageModel';
import type {OrganizationMemberModel} from '~~/package/mapper/organization/model/OrganizationMemberModel';
import type { OrganizationInviteMemberModel } from "~~/package/mapper/organization/model/OrganizationInviteMemberModel";
import type OrganizationInviteResponse from "~~/package/apis/organization/response/OrganizationInviteResponse";
import { UserV2Type } from "~~/package/mapper/user/model/UserType";
import { MemberMenuAccessRole } from "~~/package/mapper/organization/model/OrganizationMemeberTypes";
import type OrganizationAcceptInviteMemberResponse
  from '~~/package/apis/organization/response/OrganizationAcceptInviteMemberResponse';


export default class OrganizationApi {

  protected http: HttpClient;

  constructor(context: ApplicationContextInterface) {
    this.http = context.getService<HttpClient>(DependencyInjectId.HttpClient);
  }

  public getOrganizationProSkillManagerInfo(): Promise<AxiosResponse<CustomResponse<OrganizationProSkillManagerInfoModel>>> {
    return this.http.get<AxiosResponse<CustomResponse<OrganizationProSkillManagerInfoModel>>>("/org/info", undefined , true);
  }

  public getOrganizationSettingsInfo(): Promise<AxiosResponse<CustomResponse<OrganizationSettingsInfoModel>>> {
    return this.http.get<AxiosResponse<CustomResponse<OrganizationSettingsInfoModel>>>("/org/settings", undefined , true);
  }

  public getOrganizationMember(page: number, size: number, sort?: string, keyword?: string): Promise<AxiosResponse<CustomResponse<PageModel<OrganizationMemberModel>>>> {
    return this.http.get<AxiosResponse<CustomResponse<PageModel<OrganizationMemberModel>>>>("/org/members/search", { page, size, sort, keyword } , true);
  }

  public updateOrganizationSettingsInfo(name: string, size: string): Promise<AxiosResponse<CustomResponse<OrganizationSettingsInfoModel>>> {
    return this.http.put<AxiosResponse<CustomResponse<OrganizationSettingsInfoModel>>, {[key: string]: string}>('/org/settings', { name, size },true);
  }

  public deleteMyOrganization(): Promise<AxiosResponse<CustomResponse<boolean>>> {
    return this.http.delete<AxiosResponse<CustomResponse<boolean>>>('/org',{}, true);
  }

  public createOrganization(name: string, size: string): Promise<AxiosResponse<CustomResponse<boolean>>> {
    return this.http.post<AxiosResponse<CustomResponse<boolean>>, {[key: string]: string}>('/org',{name, size}, true);
  }

  public inviteOrganizationMembers(invitations: OrganizationInviteMemberModel[]): Promise<AxiosResponse<CustomResponse<OrganizationInviteResponse>>> {
    return this.http.post<AxiosResponse<CustomResponse<OrganizationInviteResponse>>, {[key: string]: OrganizationInviteMemberModel[]}>('/org/members/invitation', { invitations }, true);
  }

  public updateOrganizationMemberRole(userUuid: string, organizationRole: UserV2Type, menuAccessRoles?: MemberMenuAccessRole[]): Promise<AxiosResponse<CustomResponse<boolean>>> {
    return this.http.put<AxiosResponse<CustomResponse<boolean>>, {[key: string]: string | string[] | undefined}>(`/org/members/${userUuid}/role`, { organizationRole, menuAccessRoles }, true);
  }

  public deleteOrganizationMember(userUuids: string[]): Promise<AxiosResponse<CustomResponse<boolean>>> {
    return this.http.delete<AxiosResponse<CustomResponse<boolean>>>('/org/members', { userUuids }, true)
  }

  public acceptInviteMember(userUuid: string, orgUuid: string): Promise<AxiosResponse<CustomResponse<OrganizationAcceptInviteMemberResponse>>> {
    return this.http.post<AxiosResponse<CustomResponse<OrganizationAcceptInviteMemberResponse>>, {[key: string]: string}>(`/org/invitations/accept/member`, {userUuid, orgUuid}, true);
  }
}
